import {
    FunIcon,
    LoveIcon,
    NotSpecified,
    PurposeLoveIcon,
    PurposeCommunicationIcon,
    PurposeNotSpecifiedIcon,
} from '@/assets/icons';
import { Profile } from '@/types/profile';
import i18n from '@/i18n';

interface DataGoal {
    value: Profile['purpose'];
    illustarion: React.FC;
    text: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
}
export const dataPurposes: DataGoal[] = [
    // @ts-ignore
    { value: 'fun', illustarion: FunIcon, icon: PurposeCommunicationIcon, text: 'fun' },
    // @ts-ignore
    { value: 'love', illustarion: LoveIcon, icon: PurposeLoveIcon, text: 'love' },
    // @ts-ignore
    { value: 'not_specified', illustarion: NotSpecified, icon: PurposeNotSpecifiedIcon, text: 'not_specified' },
];

export const newDataPurposes: DataGoal[] = [
    // @ts-ignore
    { value: 'fun', illustarion: FunIcon, icon: PurposeCommunicationIcon, text: 'fun' },
    // @ts-ignore
    { value: 'love', illustarion: LoveIcon, icon: PurposeLoveIcon, text: 'love' },
    // @ts-ignore
    { value: 'not_specified', illustarion: NotSpecified, icon: PurposeNotSpecifiedIcon, text: 'not_specified' },
];
